/** Where a sidebar wheel should land, or null when the nav must not steal the page's scroll. */
export function nextSidebarScrollTop(
  scrollTop: number,
  scrollHeight: number,
  clientHeight: number,
  deltaY: number,
  overflowY: string,
): number | null {
  if (overflowY !== "auto" && overflowY !== "scroll") return null;
  const max = Math.max(0, scrollHeight - clientHeight);
  if (max <= 0) return null;
  return Math.max(0, Math.min(max, scrollTop + deltaY));
}
